import { Map } from 'immutable';

import * as Constants from '../../constants';
import { ApiActions } from '../../constants/ApiActions';
import { getFromMap } from '../../lib/CoreUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map({});

// PLAYLIST TRACK REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.ADD_FEEDBACK_SUCCESS]: handleFeedback,
  [ApiActions.DELETE_FEEDBACK_SUCCESS]: handleFeedback,
  [ApiActions.FLAG_MESSAGE_SUCCESS]: flagMessageSuccess,
  [Constants.Playback.ActionTypes.INSERT_TRACK_INTO_PLAYLIST]: insertTrackIntoPlaylist,
  [ApiActions.GET_FRAGMENT_SUCCESS]: playlistChange,
  [ApiActions.GET_REPLAY_TRACK_SUCCESS]: playlistChange,
  [Constants.Ads.Audio.Actions.REMOVE_AUDIO_AD_FROM_QUEUE]: audioAdQueueRemove,
  [Constants.Ads.Audio.Actions.ADD_AUDIO_ADS_TO_QUEUE]: audioAdQueueAdd,
  [ApiActions.FETCH_NARRATIVE_SUCCESS]: fetchNarrativeSuccess,
});

// CASE FUNCTIONS

function handleFeedback(state, action) {
  return state.mergeDeep(action.updateEntitiesWith);
}

function flagMessageSuccess(state, action) {
  return state.map(playlistTrack => {
    if (playlistTrack.get('musicId') === action.updateEntitiesWith.trackId) {
      return playlistTrack.set('isFlaggedMessage', true);
    }
    return playlistTrack;
  });
}

function insertTrackIntoPlaylist(state, action) {
  return state.map((playlistTrack, key) => {
    if (key === action.data.trackToken) {
      return playlistTrack.set(Constants.Playback.IS_REPLAYED_TRACK, true);
    }
    return playlistTrack;
  });
}

function playlistChange(state, action) {
  const playlistTrackEntities = action.response.entities.playlistTracks;

  Object.keys(playlistTrackEntities).forEach(entityId => {
    const track = playlistTrackEntities[entityId];

    if (AUDIO_URL_DEV_PROXY_DECRYPTION_KEY) {
      // For proxied encrypted tracks we need to overwrite the API response
      track.audioEncoding = Constants.AudioPlayer.AudioEncodingFormats.MP4;
    } else {
      // For all other tracks just standardize the encoding name
      track.audioEncoding =
        Constants.AudioPlayer.AudioFormatToCommonTypes[track.audioEncoding] || track.audioEncoding;
    }
  });
  return state.mergeDeep(playlistTrackEntities);
}

function audioAdQueueRemove(state, action) {
  const adTrack = action.data && action.data.ad;
  if (!adTrack) {
    return state;
  }
  const token = getFromMap(adTrack, 'trackToken');
  return state.delete(token);
}

function audioAdQueueAdd(state, action) {
  if (action.data && action.data.ads) {
    let token;
    const toMerge = {};
    action.data.ads.forEach(ad => {
      token = getFromMap(ad, 'trackToken');
      toMerge[token] = ad;
    });
    return state.mergeDeep(toMerge);
  }
  return state;
}

function fetchNarrativeSuccess(state, action) {
  if (!action.isAPSEnabled) {
    return state.mergeDeep({
      [action.updateEntitiesWith.trackToken]: {
        narrative: {
          fromTrack: true,
          ...action.response,
        },
      },
    });
  }
  return state;
}
